import { RefObject, useEffect } from 'react';

const NATIVE_ROLE_ELEMENTS = 'a[href], button, input, select, textarea';

const applyListItemRoles = (container: HTMLElement) => {
    Array.from(container.children).forEach((child) => {
        if (!child.hasAttribute('role') && !child.matches(NATIVE_ROLE_ELEMENTS)) {
            child.setAttribute('role', 'listitem');
        }
    });
};

export const useListItemRoles = (containerRef: RefObject<HTMLElement | null>, enabled = true) => {
    useEffect(() => {
        const container = containerRef.current;

        if (!enabled || !container) return undefined;

        applyListItemRoles(container);

        const observer = new MutationObserver(() => applyListItemRoles(container));

        observer.observe(container, { childList: true });

        return () => observer.disconnect();
    }, [containerRef, enabled]);
};
